import { ReportHistoryTable } from './report-upload-history-table';

export { ReportHistoryTable };
